import { exactLengthRegex, isGreaterThanRegex, onlyDecimalsRegex, onlyNumbersRegex, rangeLengthRegex, urlRegex } from "./regExp";

export const required = {validator: `required`, msg: `Este campo es obligatorio`};
export const isNumber = {validator: `isNumber`, msg: `Ingrese solo números`};
export const exactLength = (length) => ({
    validator: `matchRegexp:${exactLengthRegex(length)}`, 
    msg: `Debe ingresar ${length} caracteres`
});
export const onlyNumbers = {validator: `matchRegexp:${onlyNumbersRegex}`, msg: `Solo se admiten números`};
export const onlyDecimals = {validator: `matchRegexp:${onlyDecimalsRegex}`, msg: `Solo se admiten números decimales`};
export const validEmail = { validator: `isEmail`, msg: "Ingrese un correo electrónico válido" };
export const validUrl = { validator: `matchRegexp:${urlRegex}`, msg: "Ingrese un formato URL válida" };
export const greaterThan = (limit, msg) => ({
    validator: `matchRegexp:${isGreaterThanRegex(limit)}`,
    msg: `El valor ingresado no puede ser superior ${msg}`
});
export const rangeLength = (minLength, maxLength) => ({
    validator: `matchRegexp:${rangeLengthRegex(minLength, maxLength)}`,
    msg: `La longitud debe estar entre ${minLength} y ${maxLength} caracteres`
});